import { render, staticRenderFns } from "./BSViewTitle.vue?vue&type=template&id=4e344e40&scoped=true"
import script from "./BSViewTitle.vue?vue&type=script&lang=js"
export * from "./BSViewTitle.vue?vue&type=script&lang=js"
import style0 from "./BSViewTitle.vue?vue&type=style&index=0&id=4e344e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e344e40",
  null
  
)

export default component.exports